import { getNavigate } from './navigateHandler';
import { DataService } from '../config/dataService/dataService';

const createErrorHandling = () => {
  const fetchErrorHandling = async (request) => {
    const navigate = getNavigate();
    try {
      let response = await request();
      if (response.status == undefined || response.status === 401) {
        const accessToken = localStorage.getItem('access_token');
        const refreshToken = localStorage.getItem('refreshToken');
        const res = await DataService.post(`${process.env.REACT_APP_REFRESHTOKEN}`, {
          Token: accessToken,
          RefreshToken: refreshToken,
        });
        localStorage.removeItem('access_token');
        localStorage.removeItem('refreshToken');
        if (res.status == undefined || res.status === 401 || res.status === 400 || res.data.errorMessages?.length > 0) {
          localStorage.removeItem('logedIn');
          localStorage.clear();
          localStorage.setItem(
            'refreshTokenError',
            res.data.errorMessages?.[0] || 'Oturumunuz zaman aşımına uğramıştır. Lütfen tekrar giriş yapınız.',
          );
          navigate('/');
        } else {
          localStorage.setItem('access_token', res.data.model.token);
          localStorage.setItem('refreshToken', res.data.model.refreshToken);
          response = await request();
        }
      } else if (response.status === 400) {
        navigate('/error');
        return;
      } else if (response.status === 403) {
        navigate('/error');
        return;
      }
      return response;
    } catch (error) {
      navigate('/error');
      throw error;
    }
  };

  return fetchErrorHandling;
};

export default createErrorHandling;
